{
  "version": 1,
  "meta": {
    "id": "asymptote",
    "name": "Asymptote",
    "description": "The graduation level — approach the limit but never quite reach it",
    "author": "TriggernometryDash",
    "difficulty": "hard",
    "version": 1,
    "parTime": 80000,
    "optimalInputs": 60,
    "tags": ["multi-transition", "intense"]
  },
  "settings": {
    "initialMode": "complex",
    "initialSpeed": 1.0,
    "initialPlayerMode": "triangle",
    "baseColor": "#ff0044",
    "accentColor": "#ffffff",
    "backgroundColor": "#0a0a1a",
    "gridIntensity": 0.8,
    "music": {
      "bpm": 140,
      "key": "Am",
      "style": "synthwave",
      "song": "pulse-grid",
      "layers": ["bass", "drums", "arp", "lead", "pad"]
    },
    "fog": { "near": 50, "far": 200, "color": "#0a0a1a" }
  },
  "segments": [
    {
      "id": "seg-01-complex-opening",
      "mode": "complex",
      "length": 2000,
      "speed": 1.0,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-02-complex-ramp",
      "mode": "complex",
      "length": 1500,
      "speed": 1.3,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-03-real-breather",
      "mode": "real",
      "length": 1500,
      "speed": 1.0,
      "terrain": {
        "type": "function",
        "floor": { "function": "sin", "amplitude": 30, "frequency": 0.012, "offset": 80, "phase": 0 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 200, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 400, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 430, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 650, "across": 0, "up": 0 }, "size": { "width": 30, "height": 50 } },
        { "type": "spike", "position": { "along": 850, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 880, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1100, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1300, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-04-real-intense",
      "mode": "real",
      "length": 1500,
      "speed": 1.3,
      "terrain": {
        "type": "function",
        "floor": { "function": "cos", "amplitude": 35, "frequency": 0.015, "offset": 80, "phase": 0 },
        "ceiling": null
      },
      "obstacles": [
        { "type": "spike", "position": { "along": 100, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 250, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 280, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 450, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 480, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 510, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "wall", "position": { "along": 750, "across": 0, "up": 0 }, "size": { "width": 25, "height": 55 } },
        { "type": "spike", "position": { "along": 900, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 930, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1100, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1130, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1160, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } },
        { "type": "spike", "position": { "along": 1350, "across": 0, "up": 0 }, "size": { "width": 24, "height": 36 } }
      ],
      "decorations": []
    },
    {
      "id": "seg-05-final-complex",
      "mode": "complex",
      "length": 2500,
      "speed": 1.5,
      "terrain": { "type": "tunnel", "floor": null, "ceiling": null },
      "obstacles": [],
      "decorations": []
    }
  ],
  "triggers": [
    { "id": "trg-01", "type": "text", "position": 50, "duration": 2500, "easing": "sine-in-out", "params": { "text": "Approaching the limit...", "style": "floating" } },
    { "id": "trg-02", "type": "speed", "position": 2000, "duration": 500, "easing": "ease-in", "params": { "speed": 1.3 } },
    { "id": "trg-03", "type": "mode", "position": 3500, "duration": 2000, "easing": "sine-in-out", "params": { "targetMode": "real", "transition": "portal" } },
    { "id": "trg-04", "type": "text", "position": 3700, "duration": 2000, "easing": "sine-in-out", "params": { "text": "Back to the Real line", "style": "floating" } },
    { "id": "trg-05", "type": "color", "position": 3500, "duration": 1000, "easing": "sine-in-out", "params": { "baseColor": "#ff2244", "accentColor": "#ffaaaa" } },
    { "id": "trg-06", "type": "speed", "position": 5000, "duration": 500, "easing": "ease-in", "params": { "speed": 1.3 } },
    { "id": "trg-07", "type": "gravity", "position": 5500, "duration": 0, "easing": "linear", "params": { "direction": "up", "strength": 1.0 } },
    { "id": "trg-08", "type": "text", "position": 5500, "duration": 1500, "easing": "sine-in-out", "params": { "text": "Gravity inverts!", "style": "floating" } },
    { "id": "trg-09", "type": "gravity", "position": 6000, "duration": 0, "easing": "linear", "params": { "direction": "down", "strength": 1.0 } },
    { "id": "trg-10", "type": "mode", "position": 6500, "duration": 2000, "easing": "sine-in-out", "params": { "targetMode": "complex", "transition": "portal" } },
    { "id": "trg-11", "type": "text", "position": 6700, "duration": 2000, "easing": "sine-in-out", "params": { "text": "The Asymptote awaits...", "style": "floating" } },
    { "id": "trg-12", "type": "speed", "position": 7500, "duration": 500, "easing": "ease-in", "params": { "speed": 1.5 } },
    { "id": "trg-13", "type": "color", "position": 7500, "duration": 1000, "easing": "sine-in-out", "params": { "baseColor": "#ff0044", "accentColor": "#ffffff" } }
  ],
  "collectibles": [
    { "type": "star", "position": { "along": 1500, "across": 0, "up": 0 }, "index": 0 },
    { "type": "star", "position": { "along": 5800, "across": 0, "up": 160 }, "index": 1 },
    { "type": "star", "position": { "along": 8200, "across": 0, "up": 0 }, "index": 2 }
  ]
}
